import React, { Component } from 'react';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import Isvg from 'react-inlinesvg';
import { Label } from 'reactstrap';


/**
* Custom checkbox
* @author   Milan Stanojevic
*/
class RadioButtons extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
        const defaultValue = this.props.defaultValue;
        const items = this.props.items || [];
        if (defaultValue && items.length > 0 && !this.props.value) {
            const selectedItem = items.find(item => item.value === defaultValue);
            if (selectedItem) {
                this.onChange(selectedItem.value, true);
            }
        }
    }

    onChange = (value, force = false) => {
        if (this.props.disabled && !force) return;
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {


        const doOnChangeOnlyOnBoxClick = this.props.doOnChangeOnlyOnBoxClick ? this.props.doOnChangeOnlyOnBoxClick : false;

        const items = this.props.items || [];

        return (
            <div className='radio-buttons-component-wrap'>
                <Label>{this.props.label}</Label>
                <div className={this.props.disabled ? 'radio-buttons-list-wrap radio-buttons-component-disabled' : 'radio-buttons-list-wrap'}>
                    {
                        items?.map((item, index) => {
                            const styleBox = item.value === this.props.value ? "radio-checkbox-v2 radio-checkbox-v2-checked" : "radio-checkbox-v2";

                            return (
                                <div key={index} className='radio-button-item'>
                                    <div className={styleBox} onClick={() => this.onChange(item.value)}>

                                    </div>
                                    <div className='radio-button-label' onClick={() => this.onChange(item.value)}>{item.label}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
        // return (
        //     <div
        //         className={this.props.disabled ? this.props.disabledIcon ? "checkbox-wrap-v2 checkbox-wrap-v2-disabled checkbox-wrap-v2-disabled-icon" : "checkbox-wrap-v2 checkbox-wrap-v2-disabled" : "checkbox-wrap-v2"}
        //         onClick={(e) => {

        //             if (!this.props.onChange || doOnChangeOnlyOnBoxClick) {
        //                 return;
        //             }
        //             let obj = {
        //                 target: {
        //                     checked: !this.props.checked
        //                 }
        //             }

        //             this.props.onChange(obj);
        //         }}
        //     >
        //         <div
        //             className={styleBox}
        //             style={{ border: this.props.error ? '1px solid #dc3545' : 'none' }}
        //             onClick={() => {
        //                 if (doOnChangeOnlyOnBoxClick && this.props.onChange) {
        //                     let obj = {
        //                         target: {
        //                             checked: !this.props.checked
        //                         }
        //                     }

        //                     this.props.onChange(obj);
        //                 }
        //             }}
        //         >
        //         </div>
        //         <span
        //             style={this.props.small ? { color: this.props.error && !this.props.errorLabelDisabled ? '#dc3545' : 'black', fontSize: 14 } : { color: this.props.error && !this.props.errorLabelDisabled ? '#dc3545' : 'black' }}
        //             className={this.props.labelInfo || this.props.tooltip ? "flex-center" : ""}
        //             onClick={() => {
        //                 if (this.props.labelAction) {
        //                     this.props.labelAction();
        //                 }
        //             }}
        //         >
        //             {this.props.label}{this.props.additionalInfo ? <span style={{ color: '#758195', fontWeight: 300 }}> ({this.props.additionalInfo})</span> : null}
        //             {
        //                 this.props.labelInfo ?
        //                     <div className='label-info'>
        //                         <Isvg src={infoIcon} />
        //                         <div className="info-text">{this.props.labelInfo}</div>
        //                     </div>
        //                     :
        //                     null
        //             }
        //             {
        //                 this.props.tooltip ?
        //                     <div className='tooltip-label-info'>
        //                         <Isvg src={infoIcon} />
        //                         <div className="info-text">{this.props.tooltip}</div>
        //                     </div>
        //                     :
        //                     null
        //             }
        //         </span>
        //     </div>
        // );
    }
}

export default RadioButtons;